// extracted by mini-css-extract-plugin
module.exports = {"BreakLimits":"BreakLimits_BreakLimits__7OKk6"};